var _style, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconNotificationSmsStandard = function SvgIconNotificationSmsStandard(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.6 28.5",
    style: {
      enableBackground: "new 0 0 20.6 28.5"
    },
    xmlSpace: "preserve",
    width: 26.956,
    height: 26.996,
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#11526A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-842.238 -920)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M848.1,935.4v10.5c0,1.4,1.2,2.6,2.6,2.6h9.5c1.4,0,2.6-1.2,2.6-2.6v-19c0-1.4-1.2-2.6-2.6-2.6h-1.5 c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5l0,0h1.5c0.9,0,1.6,0.7,1.6,1.6v2.1h-4.7c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5l0,0h4.7v12.7h-12.7v-7.4c0-0.3-0.2-0.5-0.5-0.5C848.3,934.9,848.1,935.1,848.1,935.4L848.1,935.4z  M849.1,945.9v-2.1h12.7v2.1c0,0.9-0.7,1.6-1.6,1.6h-9.5C849.8,947.5,849.1,946.8,849.1,945.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M842.2,925.8c0,2.7,2.4,5.1,5.6,5.6c0.4,1.7,1.9,2.9,3.6,3c0.2,0,0.4-0.2,0.4-0.4c0-0.1,0-0.2-0.1-0.3 c-0.6-0.6-0.9-1.4-0.9-2.3c3.3-0.6,5.6-2.9,5.6-5.6c0-1.6-0.8-3.1-2.1-4.1c-3-2.2-7.1-2.2-10.1,0 C843.1,922.6,842.3,924.1,842.2,925.8z M843,925.8c0-2.8,2.9-5,6.4-5s6.4,2.2,6.4,5c0,2.4-2.2,4.5-5.3,4.9c-0.2,0-0.3,0.2-0.3,0.4 l0,0c-0.1,0.8,0,1.6,0.5,2.4c-1.1-0.3-1.9-1.3-2-2.4v0c0-0.2-0.1-0.4-0.3-0.4C845.2,930.3,843,928.2,843,925.8L843,925.8z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNotificationSmsStandard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_notification_sms_standard.427b91cc.svg";
export { ForwardRef as ReactComponent };